<style lang="scss">
@import "./styles/contact-card.scss";
</style>

<template>
  <div class="contact-card">
    <v-layout row wrap>
      <v-flex :class="'contact-card-icon-panel ' + (isRemovable && !removeAddButtons ? 'removable' : '')" xs2>
        <OnBoardCrossIcon class="contact-remove-icon" @click.native="onRemoveClick" v-if="!isSleekDirector" />
        <OnBoardDirectorAvatarIcon class="contact-director-logo" v-if="!isSleekDirector" />
        <OnBoardSleekMiniLogoIcon class="contact-sleek-director-logo" v-if="isSleekDirector && !isPartner" />
        <PartnerOnBoardSleekMiniLogoIcon class="" v-if="isSleekDirector && isPartner" />
      </v-flex>
      <v-flex xs10>
        <h3 :class="'lbl-contact-card-title ' + (isSleekDirector ? 'director' : '')">{{ displayName }}</h3>
        <p class="lbl-contact-card-email">{{ contact.email }}</p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// Icons
import OnBoardSleekMiniLogoIcon from "@shared-icons/OnBoardSleekMiniLogoIcon.vue";
import OnBoardDirectorAvatarIcon from "@shared-icons/OnBoardDirectorAvatarIcon.vue";
import OnBoardCrossIcon from "@shared-icons/OnBoardCrossIcon.vue";
import PartnerOnBoardSleekMiniLogoIcon from "@shared-icons/PartnerOnBoardSleekMiniLogoIcon.vue";

// Maps
import { Constants } from "customer-sdk/constants";

const ON_BOARDING_CONTACTS_EVENTS = Constants.ON_BOARDING_CONTACTS_EVENTS;
//#region Private Methods
let publishContactRemoved = component => {
  let { contactsTopic, contact, onBoardingTopic } = component;

  if (contactsTopic) {
    contactsTopic.publish({
      type: ON_BOARDING_CONTACTS_EVENTS.ON_CONTACT_REMOVED,
      contactCategory: component.contactCategory,
      cardId: component.cardId,
      data: {
        id: contact.id,
        isOwner: contact.isOwner,
        contactType: contact.contactType
      },
      onBoardingTopic: onBoardingTopic
    });
  }
};
//#endregion

export default {
  name: "ContactCard",
  components: {
    OnBoardSleekMiniLogoIcon,
    OnBoardDirectorAvatarIcon,
    OnBoardCrossIcon,
    PartnerOnBoardSleekMiniLogoIcon
  },
  props: {
    contact: Object,
    isSleekDirector: {
      type: Boolean,
      default: false
    },
    contactsTopic: Object,
    contactCategory: String,
    cardId: Number,
    isRemovable: {
      type: Boolean,
      default: true
    },
    onBoardingTopic: Object,
    isPartner: {
      type: Boolean,
      default: false
    },
    removeAddButtons: Boolean
  },
  computed: {
    displayName() {
      let component = this;
      let contact = component.contact;

      if (contact && contact.companyName) {
        return contact.companyName;
      }

      return `${contact.firstName} ${contact.lastName}`;
    },
    isEmailAvailable() {
      let component = this;

      if (component.contact && component.contact.email) {
        return true;
      }

      return false;
    }
  },
  data: function() {
    return {
      isAdditionalDetailsVisible: false
    };
  },
  methods: {
    onRemoveClick: async function() {
      publishContactRemoved(this);
    }
  }
};
</script>
